import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeUnsegmentedVizExternalProps } from '../../types';
import {
  OverTimeUnsegmentedBarChartActions,
  OverTimeUnsegmentedBarChartState,
} from './types';

export const useOverTimeUnsegmentedBarChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: OverTimeUnsegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeUnsegmentedBarChartState,
  OverTimeUnsegmentedBarChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: true,
      enableStack: true,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
